import React, { useEffect } from "react";
import ProjectDescription from '../components/ProjectDescription';
import { Helmet } from "react-helmet";
import { Container, Row, Col } from 'react-grid-system';
import ProjectModel from '../models/ProjectModel';
import ProjectIndex from '../components/ProjectIndex';
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import '../App.css';

function ImageCaption({ m }) {
  return (
    <div style={{ paddingTop: 12 }}>
      <div className="subhead-white" style={{ textTransform: 'none', paddingBottom: 0 }}>{m.projectName}</div>
      {m.articleLink && m.articleLink.length > 0 && (
        <div className="subhead-white" style={{ textTransform: 'none', paddingBottom: 0 }}>
          <a href={m.articleLink} target="_blank" rel="noopener noreferrer">View article</a>
        </div>
      )}
      {m.contributorRole && m.contributorRole.length > 0 && (
        <div className="subhead-white" style={{ textTransform: 'none', paddingBottom: 0 }}>
          {m.contributorRole}, <a href={m.contributorLink} target="_blank" rel="noopener noreferrer">{m.contributorName}</a>
        </div>
      )}
    </div>
  );
}

function BloombergBusinessweek({dispatch}) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  return (
    <div className="wrapper">
      <div className="inner-wrapper">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Maria Chimishkyan — {ProjectModel.BloombergBusinessweekAvon.title}</title>
        </Helmet>

        <Container fluid className="page-pad">
          <Row>
            <Col sm={3}>
              <div className="description-sticky">
                <ProjectDescription projectModel={ProjectModel.BloombergBusinessweekMisc}/>
              </div>
            </Col>
            <Col sm={6}>
              <img src="img/project-page/bloomberg-businessweek/bloomberg-businessweek-MariaChimishkyan-7.jpg" alt="Bloomberg Businessweek — Maria Chimishkyan" style={{ width: '100%' }}/>
              <ImageCaption m={ProjectModel.BloombergBusinessweekJunk} />

              <div style={{ marginTop: '100px' }}>
                <img src="img/project-page/bloomberg-businessweek/bloomberg-businessweek-MariaChimishkyan-9.jpg" alt="Bloomberg Businessweek — Maria Chimishkyan" style={{ width: '100%' }}/>
                <ImageCaption m={ProjectModel.BloombergBusinessweekRealEstate} />
              </div>

              <div style={{ marginTop: '100px' }}>
                <Row>
                  <Col sm={7}>
                    <img src="img/project-page/bloomberg-businessweek/bloomberg-businessweek-MariaChimishkyan-3.gif" alt="Bloomberg Businessweek — Maria Chimishkyan" style={{ width: '100%' }}/>
                  </Col>
                  <Col sm={5}>
                    <img src="img/project-page/bloomberg-businessweek/bloomberg-businessweek-MariaChimishkyan-4.jpg" alt="Bloomberg Businessweek — Maria Chimishkyan" style={{ width: '100%' }}/>
                  </Col>
                   <ImageCaption m={ProjectModel.BloombergBusinessweekApps} />
                </Row>
              </div>

             

              <div style={{ marginTop: '100px' }}>
                <img src="img/project-page/bloomberg-businessweek/bloomberg-businessweek-MariaChimishkyan-6.jpg" alt="Bloomberg Businessweek — Maria Chimishkyan" style={{ width: '100%' }}/>
                <ImageCaption m={ProjectModel.BloombergBusinessweekSpotify} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <ProjectIndex/>
    </div>
  );
}

export default connect()(BloombergBusinessweek);
